"use client";

import { c as _c } from "react/compiler-runtime";
import { LoginForm } from "@/components/login-form";
import { useAuth } from "@/contexts/auth-context";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
export default function LoginPage() {
  const $ = _c(7);
  const {
    isAuthenticated,
    user,
    loading
  } = useAuth();
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] !== isAuthenticated || $[1] !== loading || $[2] !== router || $[3] !== user) {
    t0 = () => {
      if (loading) {
        return;
      }
      if (isAuthenticated && user) {
        if (!user.enabled) {
          router.push("/sign-up/portal");
        } else {
          router.push("/dashboard");
        }
      }
    };
    t1 = [isAuthenticated, user, loading, router];
    $[0] = isAuthenticated;
    $[1] = loading;
    $[2] = router;
    $[3] = user;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex min-h-svh flex-col items-center justify-center bg-muted p-6 md:p-10"><div className="w-full max-w-sm md:max-w-3xl"><LoginForm /></div></div>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}